import { TERMSOFUSE, TERMSOFUSEANDROID } from './user-docs-links';

export default (): Window | null =>
    window.open(navigator.userAgent.match(/Android/i) ? TERMSOFUSEANDROID : TERMSOFUSE);
